import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "rougee_access_token";
// Global-admin location override — when set, every GET request is silently
// scoped to this location via the ?location= query param. Used by the header
// LocationSwitcher.
const LOCATION_OVERRIDE_KEY = "rougee_active_location";

export function getStoredToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export function getActiveLocation() {
  try {
    return localStorage.getItem(LOCATION_OVERRIDE_KEY) || "";
  } catch {
    return "";
  }
}

export function setActiveLocation(loc) {
  try {
    if (loc) localStorage.setItem(LOCATION_OVERRIDE_KEY, loc);
    else localStorage.removeItem(LOCATION_OVERRIDE_KEY);
  } catch {}
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach Bearer token if available — works even when cross-site cookies are blocked.
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${t}`;
    }
  }
  // Auto-inject the location override for global admins. Only for GETs (we
  // never want to override the silent location-stamp on POSTs / PATCHes), and
  // only when the caller hasn't already set a `location` param explicitly.
  const method = String(config.method || "get").toLowerCase();
  if (method === "get") {
    const loc = getActiveLocation();
    if (loc) {
      const url = String(config.url || "");
      // Skip the public locations endpoint — no auth, no scoping.
      if (!url.includes("/auth/locations") && !url.includes("/locations")) {
        config.params = config.params || {};
        if (config.params.location == null && config.params["location"] == null) {
          config.params.location = loc;
        }
      }
    }
  }
  return config;
});

export function buildFileUrl(path) {
  const t = getStoredToken();
  const qs = t ? `?auth=${encodeURIComponent(t)}` : "";
  return `${API_BASE}/files/${path}${qs}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
